module.exports = __webpack_public_path__ + "img/douyin-icon.d9f84e56.png";